<template>
    <property-common-card  v-if="property" :property="property" :checkIn="checkIn" :checkOut="checkOut" :quotePerNight="quotePerNight" :useBedsCount="useBedsCount" />
    <div v-else-if="emptyResults" class="p-3">
        Could not find the requested property.
    </div>
    <div v-else-if="error" class="p-3">
        {{ error }}
    </div>
    <div v-else class="p-5 text-center">
        <spinner />
    </div>
</template>

<script type="text/javascript">
    import PropertyCommonCard from '@/components/Content/Public/Properties/Cards/Common.vue';
    import CommonComponents from '@/components/Common.vue';

    import DateObject from '@/classes/DateObject.js';
    import { UseApiStore } from '@/store/Api.js';
    //import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            PropertyCommonCard,
            ...CommonComponents,
        },

        setup() {
            return {
                apiStore: UseApiStore(),
                //uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                error: null,
                disposed: false,
                emptyResults: null,
                requestsTimer: null,
            };
        },

        props: {

            propertyId: {
                type: Number,
                required: true,
            },

            checkIn: {
                type: DateObject,
            },

            checkOut: {
                type: DateObject,
            },

            adults: {
                type: Number,
            },

            children: {
                type: Number,
            },

            quotePerNight: {
                type: Boolean,
                default: false,
            },

            useBedsCount: {
                type: Boolean,
                default: false,
            },

            singleLineName: {
                type: Boolean,
                default: false,
            },
        },

        created() {
            if (!this.propertiesData) {
                this.requestData();
            }
        },

        watch: {
            propertyId() {
                if (!this.propertiesData) {
                    this.requestData();
                }
            },
        },

        beforeUnmount() {
            clearTimeout(this.requestsTimer);
            this.disposed = true;
        },

        computed: {
            requestUrl() {
                let re = 'properties/list';
                let params = {
                    mapPropIds: this.propertyId,
                };
                if ((this.checkIn) && (this.checkOut)) {
                    params.start = this.checkIn.format('Y-m-d');
                    params.end = this.checkOut.format('Y-m-d');
                }
                re += '?'+new URLSearchParams(params).toString();
                return re;
            },

            propertiesData() {
                let response = this.apiStore.requests[this.requestUrl];
                
                if (!response) {
                    return null;
                }

                if ((response.valid) && (response.results) && (!response.results.error)) {
                    return response.results;
                }
                else {
                    let error = 'Could not complete request';
                    if ((response.results) && (response.results.error)) {
                        if (response.results.error.message) error = response.results.error.message;
                        else error = response.results.error;
                    }
                    this.setError(error);
                }
                
                return null;
            },

            property() {
                if (
                    (this.propertiesData) &&
                    (this.propertiesData.properties) &&
                    (this.propertiesData.properties.length)
                ) {

                    for (let i=0; i<this.propertiesData.properties.length; i++) {
                        if (this.propertiesData.properties[i].id == this.propertyId) {
                            return this.propertiesData.properties[i];
                        }
                    }

                    this.setEmptyResults(true);
                }

                
                return null;
            },
        },

        methods: {
            async requestData() {
                if (this.disposed) return;
                
                this.setError(null);
                this.setEmptyResults(null);
                
                clearTimeout(this.requestsTimer);

                await this.apiStore.get(this.requestUrl);
            },

            setError(error) {
                this.error = error;
            },
            
            setEmptyResults(val) {
                this.emptyResults = val;
            },
        },
    };

</script>
